import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledUserInfo = styled(Flexbox)(
    () => css`
        overflow: hidden;
        flex: 1;
    `
)

export const StyledSpecialization = styled.span(
    ({theme: {palette, typography}}) => css`
        color: ${palette.neutral['600']};
        font-size: ${typography.textSm};
        margin-left: 4px;
    `
)

export const StyledUsersContainer = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        flex-direction: column;
        padding: ${spacing * 4}px 0;
        max-height: 300px;
        overflow-y: auto;
        width: 100%;
    `
)
